import React from 'react';
import { Layout } from "antd";
import ComingSoon from '../layouts/comingSoon.layout';


const HistoricPage  : React.FC = () => {
  return (
    <Layout>
        <ComingSoon title="Página de histórico foi apagada"/>
    </Layout>
  );
};

export default HistoricPage ;
